module.exports = __webpack_public_path__ + "media/images/eaterprises_logo-c21824f0e306549e8aebbb487dd6f371.jpg";